'use client';

export const ConsentScript = () => (
  <>
    <script
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      type="text/javascript"
      data-domain-script="70eb8bf5-e98d-49a5-98e1-2519e806b541-test"
      async
    />
    <script type="text/javascript" async>
      function OptanonWrapper() {}
    </script>
  </>
);
